export default __webpack_public_path__ + "static/media/notification.377fef97.svg";